import React from "react";
import styled from "styled-components";
import {observer} from "mobx-react";
import {useStore} from "modules/hooks";
import {FANTASY_URL} from "modules/constants";
import {Button, Title, Wrapper} from "./SupportedTeamCta";

const SWrapper = styled(Wrapper)`
	margin-top: 60px;
`;

export const FantasyCta: React.FC = observer(() => {
	const {I18n} = useStore();

	return (
		<SWrapper>
			<Title>{I18n.t("screens.final.fantasy_title")}</Title>

			<Button as="a" href={FANTASY_URL}>
				{I18n.t("screens.final.fantasy_link")}
			</Button>
		</SWrapper>
	);
});
